import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The seam between `<ParallaxBackground>` and its `<ParallaxLayer>` children. As
 * in Godot's `_update_scroll`, a layer registers its group and the background
 * poses it once per frame, outside React: a per-frame `setState` would re-render
 * every frame.
 */
import { createContext, useContext } from 'react';
const ParallaxScrollContext = createContext(null);
ParallaxScrollContext.displayName = 'ParallaxScrollContext';
export function ParallaxScrollProvider({ value, children, }) {
    return _jsx(ParallaxScrollContext.Provider, { value: value, children: children });
}
/** The enclosing ParallaxBackground's registry, or null outside one. */
export function useParallaxScrollRegistry() {
    return useContext(ParallaxScrollContext);
}
//# sourceMappingURL=scrollContext.js.map